import UserAccess from '../../../base/errors/airdome/UserAccess';

const userAccess: UserAccess = {
  unableToLoad: 'Benutzer mit Zugriff konnten nicht geladen werden'
};

export default userAccess;
